<div *ngFor="let deck of currentPitchDeck ? [currentPitchDeck] : []">
  <div class="deckWrapper">
    <a [attr.href]="deck.uri" target="_blank" style="word-break: break-word"> {{ deck.displayName }} </a>

    <markant-icon src="./assets/svg/m_trash.svg" (click)="delete()" class="markant-icon">delete</markant-icon>
  </div>
</div>

<div style="height: 20em; position: relative" [class.d-none]="!!currentPitchDeck">
  <app-continuous-action [sticky]="false"></app-continuous-action>
  <app-dropzone
    [message]="'Hier kannst Du Dein Pitch Deck hochladen'"
    accept=".pdf"
    [maxFileSize]="maxFileSize"
    (fileListChange)="handleNewFiles($event)"
    [disabled]="disabled"
  ></app-dropzone>
</div>
<mat-divider></mat-divider>
